<template>
  <b-navbar toggleable="md" fixed="top" class="head bg-white">
    <div class="nav-container container">
      <b-navbar variant="faded" type="light" class="logo">
        <b-navbar-brand href="#">
          <img src="@/assets/head-logo.png" />
        </b-navbar-brand>
      </b-navbar>
		  <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav >
          <b-nav-item :to="{name: 'Home'}"> {{ $t('route.home') }}</b-nav-item>
          <b-nav-item :to="{name: 'Abouts'}"  > {{ $t('route.about') }}</b-nav-item>
          <b-nav-item :to="{name: 'Products'}"  > {{ $t('route.product') }}</b-nav-item>
          <b-nav-item :to="{name: 'News'}"  > {{ $t('route.news') }}</b-nav-item>
          <b-nav-item :to="{name: 'Contact'}"  > {{ $t('route.contact') }}</b-nav-item>

          <b-nav-item-dropdown text="Language" right >
            <b-dropdown-item href="#" @click="handleSetLanguage('zh')">CH</b-dropdown-item>
            <b-dropdown-item href="#" @click="handleSetLanguage('en')">ENG</b-dropdown-item>
        </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </div>
  </b-navbar>
</template>

<script>
export default {

  computed: {
    language() {
      return this.$store.getters.language
    }
  },
  created() {
    console.log("设置")
  },
  methods: {
    handleSetLanguage(lang) {
      debugger
      this.$i18n.locale = lang
      this.$store.dispatch('app/setLanguage', lang)
    }
  }
}
</script>

<style scoped lang="scss">
  .head {
    border-bottom: 1px solid #f0f0f0;
    -webkit-box-shadow: 0 1px 3px rgba(26,26,26,.1);
    box-shadow: 0 1px 3px rgba(26,26,26,.1);
    .nav-container.container {
        max-width: 1406px!important;/*no*/
    }
    .logo {
        img {
            width: 200px;

        }
        a {
            padding: 0;
        }
    }
    /deep/ .nav-item {
        a {
            &:focus,
            &:hover {
                color: #33ba00;
                background-color: transparent;
            }
        }
    }
  }
  @media (min-width: 768px) {
    .head {
        padding-top: 0;
        padding-bottom: 0;
		border-bottom: 1px solid #f0f0f0;
		-webkit-box-shadow: 0 1px 3px rgba(26,26,26,.1);
		box-shadow: 0 1px 3px rgba(26,26,26,.1);
        .nav-container.container {
            padding-left: 70px;
			padding-right: 180px;
        }
        /deep/ .navbar-nav {
            width: 100%;
            justify-content: space-around;
            max-width: 850px;
        }
        /deep/ .navbar-collapse {
            justify-content: flex-end;
        }
        /deep/ .nav-item {
            flex-basis: 0;
            -ms-flex-positive: 1;
            -webkit-box-flex: 1;
            flex-grow: 1;
            max-width: 100%;
            text-align: center;
            // width: 20%;
            & > a {
                padding-top: 0;
                padding-bottom: 0;
                border-top: 4px solid transparent;
                border-bottom: 4px solid transparent;
                padding-right: 20%;
                padding-left: 20%;
                display: inline-block;
                font-size: 16px;
                color: #222222;
                height: 84px;
                display: flex;
                align-items: center;
                text-align: center;
                justify-content: center;
                &:after {
                    display: none;
                }
            }
            // &.show {
            //     & > a {
            //         border-bottom: 0.25rem solid #33ba00;
            //     }
            // }

        }
    }
}
@media (min-width: 1200px) {
    .head {
		border-bottom: 1px solid #f0f0f0;
		-webkit-box-shadow: 0 1px 3px rgba(26,26,26,.1);
		box-shadow: 0 1px 3px rgba(26,26,26,.1);
        /deep/ .nav-item {
            & > a {
                font-size: 23px;
            }
        }
    }
}
@media (min-width: 1000px) {
    .head {
		border-bottom: 1px solid #f0f0f0;
		-webkit-box-shadow: 0 1px 3px rgba(26,26,26,.1);
		box-shadow: 0 1px 3px rgba(26,26,26,.1);
        /deep/ .nav-item {
            & > a {
                font-size: 16px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Head.vue